import '@fluentui/react';

/**
 * Semantic layout-surface tokens layered on top of the Fluent palette.
 *
 * The Fluent `palette` is a luminance ramp (neutralLighterAlt -> neutralDark);
 * picking arbitrary ramp slots for layout chrome is what caused the banner,
 * nav, and content surfaces to drift apart. These tokens name the handful of
 * structural surfaces the app actually has so every chrome element references
 * the same role instead of a raw ramp slot or a color literal.
 *
 * Dark mode intent: black app background, gray chrome (banner + nav) and gray
 * containers, with chrome sitting between the black canvas and the lighter
 * cards so elevation still reads.
 */
export interface ISurfaceColors {
    /** Outermost canvas: document body and the scrollable main content region. */
    appBackground: string;
    /** App chrome: site header (banner) and primary navigation rail. */
    chrome: string;
    /** Divider/border used to separate chrome from adjacent surfaces. */
    chromeBorder: string;
    /** Subtle interactive feedback on chrome elements (e.g. header button hover). */
    chromeHover: string;
    /** Raised surfaces that sit on the canvas: cards, panels, menus. */
    container: string;
}

declare module '@fluentui/react' {
    interface Theme {
        /** SRM layout-surface tokens. Present on every theme returned by `getThemeFromString`. */
        surfaces: ISurfaceColors;
    }
}

export const lightSurfaces: ISurfaceColors = {
    appBackground: '#faf9f8',
    chrome: '#ffffff',
    chromeBorder: '#edebe9',
    chromeHover: '#f3f2f1',
    container: '#ffffff',
};

export const darkSurfaces: ISurfaceColors = {
    appBackground: '#000000',
    chrome: '#1b1b1b',
    chromeBorder: '#2b2b2b',
    chromeHover: '#2b2b2b',
    container: '#242424',
};
